import { render, staticRenderFns } from "./PromotionsInitiativeBrandAwareness.vue?vue&type=template&id=6dd4b560&scoped=true&"
import script from "./PromotionsInitiativeBrandAwareness.vue?vue&type=script&lang=ts&"
export * from "./PromotionsInitiativeBrandAwareness.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionsInitiativeBrandAwareness.vue?vue&type=style&index=0&id=6dd4b560&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd4b560",
  null
  
)

export default component.exports